import { render, staticRenderFns } from "./DashUserNav.vue?vue&type=template&id=50086b82"
import script from "./DashUserNav.vue?vue&type=script&lang=js"
export * from "./DashUserNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports